<template>

</template>

<script>
export default {
  name: "BinaListe"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Muhasebe/_/BinaListe.vue